import React from 'react';
import BootstrapDialog from '../lib/bootstrap-dialog';
import IvrStep from './IvrStep';
import {camelCaseObject} from "../lib/utils";

const UNKNOWN_STATE = -1, STARTED = 1, STEP1 = 10, STEP2 = 20, STEP3 = 30, SUBMIT = 40, COMPLETE = 50;

// Simple Bootstrap modal scaffolding
// handleClose - when modal is called
// handleAccept - when accept buttin is clicked
class IvrStageDialog extends BootstrapDialog {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.getIvrStep = this.getIvrStep.bind(this);
        this.getIvrStatus = this.getIvrStatus.bind(this);
        this.getIvrStatusMsg = this.getIvrStatusMsg.bind(this);
        this.handleAcceptClick = this.handleAcceptClick.bind(this);
        this.stopIvrStatusTimer = this.stopIvrStatusTimer.bind(this);
    }

    handleClose() {
        console.debug('IvrStageDialog handleClose()');
        const {setValue} = this.props;
        this.stopIvrStatusTimer();
        if (this.props.handleStageDlgClose) {
            this.props.handleStageDlgClose();
        }
        // cleanup
        setValue('ivrStatus', null);
        setValue('ivrStep', UNKNOWN_STATE);
        setValue('ivrStatusMsg', null);
    }

    handleAcceptClick() {
        this.props.handleAccept();
    }

    componentDidMount() {
        this.ivrStatusTimer = setInterval(this.getIvrStatus, 5000);
    }

    getIvrStatus() {
        const {setValue, data, config} = this.props, {stagedId, paymentMethod} = data;
        console.debug(`getting staged payment status for stagedId: ${stagedId}`);
        let url = `./stage-payment-ivr-status.do?CSRF_TOKEN=${config.csrf}`;
        let postData =  `header.stagingId=${stagedId}`;
        if(data.payments && data.payments.length > 1) {
            // multiPayment url and postData
            const {stagingGroupId} = data;
            url = `./mp-stage-payment-ivr-status.do?CSRF_TOKEN=${config.csrf}`;
            postData = `stagingId=${stagedId}&transactionGroupId=${stagingGroupId}`;
        }
        $.ajax({
            method: 'POST',
            url: url,
            data: postData,
            dataType: "json",
            success: (ivrStatus) => {
                ivrStatus = camelCaseObject(ivrStatus) || {};
                setValue('ivrStatus', ivrStatus);
                let ivrStep = this.getIvrStep(ivrStatus);
                setValue('ivrStep', ivrStep);
                let ivrStatusMsg = this.getIvrStatusMsg(ivrStatus, ivrStep);
                setValue('ivrStatusMsg', ivrStatusMsg);
                if (ivrStep === COMPLETE) {
                    this.stopIvrStatusTimer();
                    let {referenceNumber, paymentDate, statusCode, statusDescription, routingNumber, accountNumber, paymentMethodTypeCode} = ivrStatus;
                    paymentMethod.type = paymentMethodTypeCode;
                    paymentMethod.accountNumber = accountNumber;
                    paymentMethod.routingNumber = routingNumber;
                    let paymentResponse = {
                        referenceNumber, paymentDate,
                        paymentStatus: statusCode,
                        paymentStatusDescription: statusDescription
                    };
                    setValue('paymentResponse', paymentResponse);

                    // show receipt
                    setValue('showReceipt', true);
                } else if (ivrStatus.hangup || ivrStatus.zeroOut) {
                    this.stopIvrStatusTimer();
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.log('Error: ', jqXHR, textStatus, errorThrown);
            }
        });
    }

    // determine the step we are on
    getIvrStep(ivrStatus) {
        const {data} = this.props,
            {paymentMethod} = data, {paymentMethodCategory} = paymentMethod,
            {step, statusCode} = ivrStatus;
        if (statusCode) {
            return COMPLETE;
        }

        if (paymentMethodCategory === 'CC_IVR' || paymentMethodCategory === 'DC_IVR') {
            if (step === 'creditCard') {
                return STEP1;
            } else if (step === 'expDate') {
                return STEP2;
            } else if (step === 'cvv') {
                return STEP3;
            } else if (step === 'makeOperation') {
                return SUBMIT;
            }
        } else if (paymentMethodCategory === 'DD_IVR') {
            if (step === 'routingNumber') {
                return STEP1;
            } else if (step === 'echeckAccount') {
                return STEP2;
            } else if (step === 'makeOperation') {
                return SUBMIT;
            }
        } else if (paymentMethodCategory === 'PD_IVR') {
            if (step === 'atmCard') {
                return STEP1;
            } else if (step === 'makeOperation') {
                return SUBMIT;
            }
        }
        // no specific step found, but the flow has been started
        if (step) {
            return STARTED;
        }
        return UNKNOWN_STATE;
    }

    getIvrStatusMsg(ivrStatus, ivrStep) {
        const {config} = this.props, {messages} = config;
        if (ivrStep === COMPLETE) {
            if (ivrStatus.success) {
                return messages["transfer.payment.success"];
            } else if (ivrStatus.declined) {
                return messages["transfer.payment.declined"];
            } else {
                return messages["transfer.payment.failed"];
            }
        } else if (ivrStatus.hangup) {
            if (ivrStatus.zeroOut) {
                return messages["transfer.zeroOut.text"];
            } else if (ivrStatus.toAgent) {
                return messages["transfer.callBack.text"];
            }
            return messages["transfer.hangup.text"];
        } else if (ivrStep === SUBMIT) {
            return this.processingStepLabel();
        } else if (ivrStep > 0 && ivrStep < SUBMIT) {
            return messages["transfer.inProgress.text"];
        }
        return messages["transfer.notStarted.text"];
    }

    stopIvrStatusTimer() {
        if (this.ivrStatusTimer) {
            console.debug('Stopping staged IVR status update timer');
            clearInterval(this.ivrStatusTimer);
            this.ivrStatusTimer = null;
        }
    }

    render() {
        const {config, data} = this.props,
            {paymentMethod} = data, {paymentMethodCategory} = paymentMethod,
            {messages} = config;

        return (
            <BootstrapDialog aria-labelledby="modal-staged-ivr-title" aria-hidden="true" handleClose={this.handleClose}>
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"
                                id="modal-staged-ivr-title">{messages["transfer.dialog.title"]}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label={messages["closeButton.label"]}>
                                <span aria-hidden="true">
                                    <i className="material-icons">{messages["icon.material.close.label"]}</i>
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <table
                                className="table table-ivr-transfer table-hover table-sm-custom table-bordered-minimal">
                                <thead>
                                <tr>
                                    <th className="ivr-transfer-phone-col dark-grey-text">{messages["transfer.conference.label"]}</th>
                                    {/**<th className="ivr-transfer-callback-col dark-grey-text">{messages["transfer.parkNumber.label"]}</th>*/}
                                    <th className="ivr-transfer-access-col dark-grey-text">{messages["transfer.stagedRefNr.label"]}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="ivr-transfer-phone-col dark-grey-text">{messages["transfer.conf.number.label"]}</td>
                                    {/**<td className="ivr-transfer-callback-col dark-grey-text">1335</td>*/}
                                    <td className="ivr-transfer-access-col dark-grey-text">{data.stagedId}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div className="ivr-transfer-container">
                                <div className="ivr-transfer-status-container">
                                    <div className="row">
                                        <div className="col-12">
                                            {paymentMethodCategory === 'DD_IVR' ? this.renderDdProgress() : paymentMethodCategory === 'PD_IVR' ? this.renderPdProgress() : this.renderCcProgress()}
                                        </div>
                                    </div>
                                    <div className="ivr-transfer-call-container">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="ivr-transfer-call-boxes">
                                                    <div
                                                        className="ivr-transfer-call-box ivr-transfer-progress-msg ivr-transfer-call-msg">
                                                        <div className="ivr-transfer-call-step-name">
                                                            {messages["transfer.status.text"]}</div>
                                                        <div className="ivr-transfer-call-step-desc">
                                                            {data.ivrStatusMsg || messages["transfer.notStarted.text"]}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="ivr-dialog-close-msg mt-3 ml-1">{this.closeWarningMessage()}</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button id="btn-ivr-transfer-cancel" type="button" className="btn btn-danger"
                                    data-dismiss="modal">{messages["closeButton.label"]}
                            </button>
                        </div>
                    </div>
                </div>
            </BootstrapDialog>
        );
    }

    renderCcProgress() {
        const {config, data} = this.props, {messages} = config;

        return (
            <div className="ivr-transfer-status-boxes">
                <IvrStep data={data} stepName={messages["payment.cardNumber.label"]} stepNumber={STEP1}/>
                <IvrStep data={data} stepName={messages["payment.cardExpiryDate.label"]} stepNumber={STEP2}/>
                <IvrStep data={data} stepName={messages["payment.cvv.label"]} stepNumber={STEP3}/>
                <IvrStep data={data} stepName={this.processingStepLabel()} stepNumber={SUBMIT}/>
            </div>);
    }

    renderDdProgress() {
        const {config, data} = this.props, {messages} = config;

        return (
            <div className="ivr-transfer-status-boxes">
                <IvrStep data={data} stepName={messages["payment.routingNumber.label"]} stepNumber={STEP1}/>
                <IvrStep data={data} stepName={messages["payment.accountNumber.label"]} stepNumber={STEP2}/>
                <IvrStep data={data} stepName={this.processingStepLabel()} stepNumber={SUBMIT}/>
            </div>);
    }

    renderPdProgress() {
        const {config, data} = this.props, {messages} = config;

        return (
            <div className="ivr-transfer-status-boxes">
                <IvrStep data={data} stepName={messages["payment.cardNumber.label"]} stepNumber={STEP1}/>
                <IvrStep data={data} stepName={this.processingStepLabel()} stepNumber={SUBMIT}/>
            </div>);
    }

    closeWarningMessage() {
        return messages["transfer.dialog.close.warning.msg"];
    }

    processingStepLabel() {
        return messages["transfer.payment.processing"];
    }
}

export default IvrStageDialog;